import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, NgForm, Validators, FormGroup, FormControl } from "@angular/forms";
import * as _ from 'lodash';
import { AuthService } from "../../../core/auth/auth.service";
import { MessageService } from "primeng/components/common/messageservice";
import { ReferralsService } from "../../../core/referrals/referrals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {Environment} from "../../../core/environment-core";
import {ReferInfoResponse} from "../../../core/referrals/refer-info-response";
declare var $;
@Component({
    selector: 'refer',
    templateUrl: 'refer.component.html',
    styleUrls: ['refer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ReferComponent implements OnInit, AfterViewInit {

    referForm: FormGroup;
    isLoading: boolean = true;
    urls: any[];
    selectedUrls: any[] = [];
    referKey: string = '';
    eventList: any[] = [];

    eventsFromService: any[] = [];

    memberFields: any[];
    selectedMemberFields: any[] = [];

    referActive: boolean = true;
    url_utm: string = '';


    utmSourceCheck: boolean = false;
    utmMediumCheck: boolean = false;
    utmCampaignCheck: boolean = false;
    utmTermCheck: boolean = false;
    utmContentCheck: boolean = false;

    constructor(
        public environment: Environment,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private _route: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private authService: AuthService,
        private referralsService: ReferralsService
    ) {
    }


    ngOnInit() {
        this.initForm(null);
        this._route.params.subscribe(params => {
            this.referKey = params['refer'];
            if (params['refer'] != 'new') {
                this.getReferralByKey();
                //this.retrievePromotion(this.referKey);
            } else {
                this.initForm(null);
                this.initEventsList(null);
                this.isLoading = false;
                //this.referKey.principal = false;
            }
        });

        this.memberFields = [
            { field: 'username', description: 'Email de usuario' },
            { field: 'active', description: 'Usuario activo/inactivo' },
            { field: 'creationDate', description: 'Fecha de creación' },
            //{ field: 'activationDate', description: 'Fecha de activación' },
            { field: 'firstName', description: 'Nombre' },
            { field: 'lastName', description: 'Apellido paterno' },
            { field: 'middleName', description: 'Apellido materno' },
            { field: 'birthday', description: 'Fecha de nacimiento' },
            { field: 'phoneNumber', description: 'Celular' }
            //{ field: 'city', description: 'Ciudad' },
            //{ field: 'birthday', description: 'cumpleaños de usuario' },
            //{ field: 'state', description: 'Estado de usuario' },
        ];
        //this.selectedMemberFields.push({ "field": "birthday", "description": "cumpleaños de usuario", "_$visited": true });


        this.getUrlsInfo();
    }

    ngAfterViewInit() {

    }

    changeCheck(event, component) {
        if (component == 'utmSourceCheck')
            this.utmSourceCheck = !this.utmSourceCheck;
        if (component == 'utmMediumCheck')
            this.utmMediumCheck = !this.utmMediumCheck;
        if (component == 'utmCampaignCheck')
            this.utmCampaignCheck = !this.utmCampaignCheck;
        if (component == 'utmTermCheck')
            this.utmTermCheck = !this.utmTermCheck;
        if (component == 'utmContentCheck')
            this.utmContentCheck = !this.utmContentCheck;
        console.log(event);
    }


    private initEventsList(beans) {
        if (beans) {
            _.forEach(beans, bean => {
                let variables: any[] = [];
                _.forEach(bean.variableBeans, variable => {
                    let field = _.find(this.memberFields, field => field.field == variable.value);
                    variables.push({ "field": field.field, "description": field.description, "_$visited": true });
                })

                this.eventList.push(
                    {
                        url: bean ? bean.url : null,//{ "id": null, "url": "juegos/home", "name": "juegos page", "description": "pagina de juegos" },
                        event: bean ? bean.event : '',
                        action: bean ? bean.action : '',
                        category: bean ? bean.category : '',
                        label: bean ? bean.label : '',
                        variableBeans: variables,
                        idReferralMap: bean ? bean.idReferralMap : '',
                        referralKey: bean ? bean.referralKey : '',
                        idUrl: bean ? bean.idUrl : '',
                    }
                )
            });
        } else {
            this.eventList.push(
                {
                    url: null,//{ "id": null, "url": "juegos/home", "name": "juegos page", "description": "pagina de juegos" },
                    event: '',
                    action: '',
                    category: '',
                    label: '',
                    variableBeans: null,
                    idReferralMap: '',
                    referralKey: this.referKey,
                    idUrl: '',
                }
            )
        }

    }

    private getReferralByKey() {
        this.isLoading = true;
        this.referralsService.getReferByKey(this.referKey)
            .finally(() => this.isLoading = false)
            .subscribe(response => {
                this.initForm(response);
                this.eventsFromService = response.mapBeans;
                this.initEventsList(response.mapBeans);
                console.log('mostramos las URLS', response)
            },
                error => {
                    console.error(error);
                });
    }

    private getUrlsInfo() {
        this.referralsService.getUrls()
            //.finally(() => this.isLoading = false)
            .subscribe(response => {
                this.urls = response;
                console.log('mostramos el response', response)
            },
                error => {
                    console.error(error);
                });
    }

    activeRefer() {
        this.referActive = this.referActive ? false : true;
    }

    deleteEvent(eventDelete) {
        _.remove(this.eventList, event => event == eventDelete);
    }

    updateRefer() {
        this.messageService.clear();
        if (this.referForm.valid) {
            let model = this.fillModel();;
            model.referralKey = this.referKey;
            this.referralsService.pathcReferral(model)
                .subscribe(success => {
                    console.log("SUCCESS", success)
                    this.messageService.add({
                        severity: 'success',
                        summary: '',
                        detail: 'La promoción se actualizo exitosamente.'
                    });
                    this.goBack();
                },
                    error => {
                        this.refreshFieldsList();
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'ocurrio un problema al actualizar, intentalo nuevamente'
                        });
                        console.error(error);
                    });
        }
    }

    onSubmit() {
        this.messageService.clear();
        if (this.referForm.valid) {
            let model = this.fillModel();
            console.log(model);
            this.referralsService.saveReferral(model)
                .subscribe(success => {
                    this.goBack();
                    this.messageService.add({
                        severity: 'success',
                        summary: '',
                        detail: 'La promoción se guardo exitosamente.'
                    });
                    console.log("SUCCESS", success)
                },
                    error => {
                        this.refreshFieldsList();
                        this.messageService.add({
                            severity: 'error',
                            summary: '',
                            detail: 'ocurrio un problema al guardar, intentalo nuevamente'
                        });
                        console.error(error);
                    });
        }

    }

    goBack() {
        this.router.navigate(['/ganalottodo/refers']);
    }

    private refreshFieldsList() {
        _.forEach(this.eventList, bean => {
            let variables: any[] = [];
            _.forEach(bean.variableBeans, variable => {
                let field = _.find(this.memberFields, field => field.field == variable.value);
                variables.push({ "field": field.field, "description": field.description, "_$visited": true });
            })
            bean.variableBeans = variables;
        });
    }

    private fillModel(): any {
        let model = this.referForm.value;

        model.utmSource = this.utmSourceCheck ? this.referForm.get('utmSource').value : '';
        model.utmMedium = this.utmMediumCheck ? this.referForm.get('utmMedium').value : '';
        model.utmCampaign = this.utmCampaignCheck ? this.referForm.get('utmCampaign').value : '';
        model.utmTerm = this.utmTermCheck ? this.referForm.get('utmTerm').value : '';
        model.utmContent = this.utmContentCheck ? this.referForm.get('utmContent').value : '';

        model.active = this.referActive;

        if (this.eventList.length > 0) {
            let i = 0;
            _.forEach(this.eventList, event => {
                let y = 0;
                let v: any[] = [];
                _.forEach(event.variableBeans, variable => {
                    if (this.eventsFromService.length - 1 >= i) {
                        console.log(this.eventsFromService[i].variableBeans.length - 1, y);
                        v.push({
                            idVariable: (this.eventsFromService[i].variableBeans.length - 1) >= y ? this.eventsFromService[i].variableBeans[y].idVariable : '',
                            value: variable.field
                        });
                    } else {
                        v.push({ idVariable: '', value: variable.field });
                    }
                    y++;
                });
                event.variableBeans = v;
                event.idUrl = event.url.id;
                i++;
            });
            model.mapBeans = this.eventList;
        }
        return model;
    }


    private initForm(referData) {
        this.referForm = this.formBuilder.group({
            name: [referData ? referData.name : '', Validators.required],
            utmSource: [referData ? referData.utmSource : ''],
            utmMedium: [referData ? referData.utmMedium : ''],
            utmCampaign: [referData ? referData.utmCampaign : ''],
            utmTerm: [referData ? referData.utmTerm : ''],
            utmContent: [referData ? referData.utmContent : '']
        });
        this.utmSourceCheck = referData ? referData.utmSource : false;
        this.utmMediumCheck = referData ? referData.utmMedium : false;
        this.utmCampaignCheck = referData ? referData.utmCampaign : false;
        this.utmTermCheck = referData ? referData.utmTerm : false;
        this.utmContentCheck = referData ? referData.utmContent : false;
        this.referActive = referData ? referData.active : false;
        if(referData)
            this.builtUrl(referData);
    }


    addOne() {
        this.initEventsList(null);

    }

    private builtUrl(refer) {
        if (refer.utmSource && refer.utmSource.length > 0) {
            this.url_utm = this.url_utm + '&utm_source=' + refer.utmSource;
        }
        if (refer.utmMedium && refer.utmMedium.length > 0) {
            this.url_utm = this.url_utm + '&utm_medium=' + refer.utmMedium;
        }
        if (refer.utmCampaign && refer.utmCampaign.length > 0) {
            this.url_utm = this.url_utm + '&utm_campaign=' + refer.utmCampaign;
        }
        if (refer.utmTerm && refer.utmTerm.length > 0) {
            this.url_utm = this.url_utm + '&utm_term=' + refer.utmTerm;
        }
        if (refer.utmContent && refer.utmContent.length > 0) {
            this.url_utm = this.url_utm + '&utm_content=' + refer.utmContent;
        }
    }



}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/referrals/admin-refer/refer.component.ts